
dojo.require("wc.service.common");
dojo.require("dijit.registry");

petcoAddToCartJS = {
	langId: WCParamJS.langId,
	storeId: WCParamJS.storeId,
	catalogId: WCParamJS.catalogId,
	AddItem2ShopCartAjaxFromRecommendation : function(partnumber, elementId){
			var LOCALSTORAGE_STORES_KEY = 'petcostores';
			if (null == localStorage.getItem(LOCALSTORAGE_STORES_KEY)) {
				var petcoNearestLocationsInitScript =  document.getElementById("petcoNearestLocationsInitScript");
				if( petcoNearestLocationsInitScript != null){
					eval(petcoNearestLocationsInitScript.innerHTML);
				}
			}
			var params = [];
			params.storeId		= WCParamJS.storeId;
			params.catalogId	= WCParamJS.catalogId;
			params.langId		= WCParamJS.langId;
			params.orderId		= ".";
			params.calculationUsage = "-1";
			params.inventoryValidation = "true";
			var defaultShipMode= petcoAddToCartJS.getShipModeIdForDefault();
			var defaultFFMCenter = petcoAddToCartJS.getFfmCenterDefault();
			params.partNumber = partnumber;
			params.inventoryValidation = "true";
			params.quantity		= '1';
			var ajaxShopCartService = "AjaxAddRecommendedItemToCart";


												if(document.getElementById("selectedRecommendationElement") != undefined){
				document.getElementById("selectedRecommendationElement").value = elementId;
			}

			if(!submitRequest()){
				return;
			}
			cursor_wait();		
			if(typeof(shoppingActionsServicesDeclarationJS) != "undefined"){
				shoppingActionsServicesDeclarationJS.setCommonParameters(WCParamJS.langId,WCParamJS.storeId,WCParamJS.catalogId);
			}
			wc.service.invoke(ajaxShopCartService, params);
			if(typeof(productDisplayJS) != "undefined"){
			 productDisplayJS.baseItemAddedToCart=true;
			}

				},
	getShipModeIdForDefault:function(){
		var defaultShipMode = "";
		var LOCALSTORAGE_STORES_KEY = 'petcostores';
		var oShipModes = JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY)) != null ? JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY)) : {};
		if(typeof(oShipModes.shipmodes) != "undefined" && oShipModes.shipmodes.length > 0 ){
			var shipmodes = JSON.parse(oShipModes.shipmodes);
			if(typeof(shipmodes.DEFAULT_SHIPMODE) != "undefined"){
				defaultShipMode = shipmodes.DEFAULT_SHIPMODE;
			}
		}
		return defaultShipMode;
	},
	getFfmCenterDefault:function(){
		var defaultFfmCeter = "";
		var LOCALSTORAGE_STORES_KEY = 'petcostores';
		var oShipModes = JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY)) != null ? JSON.parse(localStorage.getItem(LOCALSTORAGE_STORES_KEY)) : {};
		if(typeof(oShipModes.shipmodes) != "undefined" && oShipModes.shipmodes.length > 0 ){
			var shipmodes = JSON.parse(oShipModes.shipmodes);
			if(typeof(shipmodes.DEFAULT_FFMCENTER) != "undefined"){
				defaultFfmCeter = shipmodes.DEFAULT_FFMCENTER;
			}
		}
		return defaultFfmCeter;
	},
}

wc.service.declare({
	id: "AjaxAddRecommendedItemToCart",
	actionId: "AjaxAddRecommendedItemToCart",
	url: getAbsoluteURL() + "AjaxOrderChangeServiceItemAdd",
	formId: ""	
	,successHandler: function(serviceResponse) {
		setTimeout(function(){
			$('#mini-cart').css('visibility', 'visible');
			var miniCartActiveItem = "<div class=\"mini-cart-active-item\"><span class=\"glyphicon glyphicon-ok\"></span> Item successfully added to cart.</div>";
			$('.mini-cart-item').first().append(miniCartActiveItem);					
			setTimeout(function(){
				$('#mini-cart').css('visibility', 'hidden');
				$('div.mini-cart-active-item').remove();
			},3000);
		},1000);	

				if(document.getElementById("headerShopCartLink")&&document.getElementById("headerShopCartLink").style.display != "none") {
			document.getElementById("headerShopCart").focus();
		} else {
			if(document.getElementById("headerShopCart1")){
				document.getElementById("headerShopCart1").focus();
			}
		}
		dojo.require("dijit.registry");
		MessageHelper.hideAndClearMessage();			
		cursor_clear();
		if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
			ShipmodeSelectionExtJS.setOrderItemId(serviceResponse.orderItemId[0]);
		}
		dojo.publish("CMAddToCart");			

				var omnitureEnabled;
		if(null != $('#omnitureEnabled') && undefined != $('#omnitureEnabled')) {
			omnitureEnabled = $('#omnitureEnabled').val();
		}	

				if(omnitureEnabled != "undefined" && null != omnitureEnabled && omnitureEnabled !='' && omnitureEnabled == 'true'){
			var cartEventDetails = {};
			var elementIdPrefix = document.getElementById("selectedRecommendationElement").value;
			var elementId = elementIdPrefix + "-addToCartBtn";
			var productNameTaggingElement =  elementIdPrefix + "-productName-tagging";
			var partNumberTaggingElement =  elementIdPrefix + "-partNumber-tagging";	
			var productName = "";
			var partNumber = "";
			var formattedProductName = "";
			if(document.getElementById(productNameTaggingElement) != undefined){
				productName = document.getElementById(productNameTaggingElement).value;
				formattedProductName = productName.replace(/["']/g, "");
			}
			if(document.getElementById(partNumberTaggingElement) != undefined){
				partNumber = document.getElementById(partNumberTaggingElement).value;
			}

						var cartOrderId = dojo.cookie("WC_CartOrderId_10151");
			if(cartOrderId == '' || cartOrderId == null || cartOrderId == 'undefined'){
				cartEventDetails["event_name"] = "cart_open";
				cartEventDetails["cart_id"] = serviceResponse.orderId[0];
			} else{
				cartEventDetails["event_name"] = "cart_add";
				cartEventDetails["cart_id"] = cartOrderId;
			}

						cartEventDetails["product_sku"] = partNumber;
			cartEventDetails["product_name"] = formattedProductName;
			cartEventDetails["add_to_cart_quantity"] = "1";
			cartEventDetails["product_delivery_type"] = "one time";		
			pushEvent(cartEventDetails,elementId);
		}

				var zipCode = "";
		if($("#isSDDeliveryEnabled").length > 0 && 'true' == $("#isSDDeliveryEnabled").val()){
			if(null != localStorage.getItem("USER_SET_ZIP")){
				zipCode= localStorage.getItem("USER_SET_ZIP");
			}else if(null != sessionStorage.getItem("USER_SET_ZIP")){
				zipCode= sessionStorage.getItem("USER_SET_ZIP");
			}
		}

		document.location.href = getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-7&calculationUsageId=-6&orderId=.&langId="+ petcoAddToCartJS.langId + "&catalogId=" + petcoAddToCartJS.catalogId + "&storeId=" +petcoAddToCartJS.storeId + "&zipCode="+zipCode + "&sddOrderItem=" + serviceResponse.orderItemId[0] +"&errorViewName=AjaxOrderItemDisplayView&callToODM=true&updatePrices=1&URL=" + encodeURIComponent(getAbsoluteURL() + "OrderCalculate?calculationUsageId=-1&calculationUsageId=-7&orderId=.&langId="+ petcoAddToCartJS.langId + "&catalogId=" + petcoAddToCartJS.catalogId + "&storeId=" + petcoAddToCartJS.storeId + "&errorViewName=AjaxOrderItemDisplayView&callToODM=false&updatePrices=1&URL="+encodeURIComponent(getAbsoluteURL() + "OrderItemDisplay?doInventory=Y&orderId=.&langId="+ petcoAddToCartJS.langId + "&catalogId=" + petcoAddToCartJS.catalogId + "&storeId=" + petcoAddToCartJS.storeId));
	}	
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			petcoCommonJS.showModalNotificationAlert(serviceResponse.errorMessage);
			cursor_clear();
			return false;
		} else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
});
